<div class="animate-pulse bg-[#DDDEE0] aspect-[2/1]"></div>
